module.exports = __webpack_public_path__ + "static/bebauung1-4f2d27ee5f076a0c12457d57690af83e.png";